var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M423.796,512H88.203c-19.759,0-35.835-15.785-35.835-35.189V92.187 c0-19.656,15.991-35.647,35.647-35.647h335.783c19.761,0,35.835,15.785,35.835,35.189v190.049c0,7.949-6.445,14.393-14.393,14.393 s-14.393-6.444-14.393-14.393V91.729c0-3.531-3.162-6.402-7.048-6.402H88.014c-3.783,0-6.86,3.077-6.86,6.86v384.624 c0,3.531,3.162,6.402,7.048,6.402h335.595c3.886,0,7.048-2.873,7.048-6.402V372.17c0-7.949,6.445-14.393,14.393-14.393 s14.393,6.444,14.393,14.393v104.641C459.633,496.213,443.557,512,423.796,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B2B0"
    },
    d: "M311.339,71.967c0.049-0.953,0.076-1.913,0.076-2.879c0-30.207-24.487-54.695-54.695-54.695 s-54.695,24.487-54.695,54.695c0,0.966,0.027,1.926,0.076,2.879h-65.568v53.253h238.932V71.967H311.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M375.464,139.613h-238.93c-7.949,0-14.393-6.444-14.393-14.393V71.967 c0-7.949,6.444-14.393,14.393-14.393h52.057C194.089,24.939,222.546,0,256.719,0s62.631,24.939,68.128,57.574h50.617 c7.948,0,14.393,6.444,14.393,14.393v53.253C389.858,133.169,383.414,139.613,375.464,139.613z M150.928,110.826h210.143V86.36 h-49.733c-3.945,0-7.719-1.619-10.437-4.481c-2.717-2.861-4.141-6.713-3.937-10.654c0.036-0.708,0.056-1.421,0.056-2.137 c0-22.222-18.08-40.301-40.301-40.301s-40.301,18.08-40.301,40.301c0,0.717,0.02,1.429,0.058,2.137 c0.203,3.941-1.221,7.793-3.938,10.654c-2.717,2.861-6.49,4.481-10.437,4.481h-51.173L150.928,110.826L150.928,110.826z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.536,
    y: 181.875,
    style: {
      fill: "#F4B2B0"
    },
    width: 122.341,
    height: 47.498
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M258.875,243.761H136.534c-7.949,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.444-14.393,14.393-14.393h122.342c7.948,0,14.393,6.444,14.393,14.393v47.498 C273.268,237.317,266.825,243.761,258.875,243.761z M150.928,214.974h93.556v-18.711h-93.556V214.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M375.464,243.761h-57.575c-7.948,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.445-14.393,14.393-14.393h57.575c7.948,0,14.393,6.444,14.393,14.393s-6.445,14.393-14.393,14.393h-43.182v18.711 h43.182c7.948,0,14.393,6.444,14.393,14.393S383.414,243.761,375.464,243.761z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.536,
    y: 387.7,
    style: {
      fill: "#F4B2B0"
    },
    width: 122.341,
    height: 47.498
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M258.875,449.586H136.534c-7.949,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.444-14.393,14.393-14.393h122.342c7.948,0,14.393,6.444,14.393,14.393v47.498 C273.268,443.142,266.825,449.586,258.875,449.586z M150.928,420.799h93.556v-18.711h-93.556V420.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M375.464,449.586h-57.575c-7.948,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.445-14.393,14.393-14.393h57.575c7.948,0,14.393,6.444,14.393,14.393s-6.445,14.393-14.393,14.393h-43.182v18.711 h43.182c7.948,0,14.393,6.444,14.393,14.393C389.858,443.142,383.414,449.586,375.464,449.586z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.122,
    y: 284.787,
    style: {
      fill: "#F4B2B0"
    },
    width: 122.341,
    height: 47.498
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M375.464,346.673H253.123c-7.949,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.444-14.393,14.393-14.393h122.341c7.948,0,14.393,6.444,14.393,14.393v47.498 C389.858,340.229,383.414,346.673,375.464,346.673z M267.517,317.887h93.554v-18.711h-93.554V317.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M194.109,346.673h-57.575c-7.949,0-14.393-6.444-14.393-14.393v-47.498 c0-7.949,6.444-14.393,14.393-14.393h57.575c7.949,0,14.393,6.444,14.393,14.393s-6.444,14.393-14.393,14.393h-43.182v18.711 h43.182c7.949,0,14.393,6.444,14.393,14.393C208.503,340.229,202.059,346.673,194.109,346.673z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyData);
export default __webpack_public_path__ + "static/media/survey-data.3feb2212680fab3226ed6512885da686.svg";
export { ForwardRef as ReactComponent };